import { render, staticRenderFns } from "./neilinggoods.vue?vue&type=template&id=5b6cb992&scoped=true&"
import script from "./neilinggoods.vue?vue&type=script&lang=js&"
export * from "./neilinggoods.vue?vue&type=script&lang=js&"
import style0 from "./neilinggoods.vue?vue&type=style&index=0&id=5b6cb992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cb992",
  null
  
)

export default component.exports